import { useTranslation } from 'react-i18next';
////////////////////////////////////////////////////////
import { CoinImage } from '@/app/shared/components';

export const LoadingScreen: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/
	return (
		<div
			style={{
				backgroundImage: `url('${process.env.VITE_LOADER_IMAGE}')`,
			}}
			className={`relative flex flex-col w-full min-h-svh bg-no-repeat bg-center justify-end bg-cover`}
		>
			{/* Spacer */}
  			<div className="flex-1" />

			{/* Overlay */}
  			{/* <div className="absolute inset-0 bg-black/50" /> */}
			<div className="flex flex-col justify-self-end items-center space-y-5 mx-4">
				<div className="flex">
					<div className="animate-bounce">
						<CoinImage classes="animate-spin w-[40px]" />
					</div>
					<div className="animate-bounce delay-75">
						<CoinImage classes="animate-spin duration-1000 w-[40px]" />
					</div>
					<div className="animate-bounce delay-150">
						<CoinImage classes="animate-spin duration-1000 w-[40px]" />
					</div>
				</div>

				<p className="text-xl font-bold">{t('loading.title')}</p>
				<p className="text-base font-semibold">
					{t('loading.description')}
				</p>
			</div>
		</div>
	);
};
